import React from "react";
const SortButtonBase = ({ className }) => {
  return <button className={"sort-button " + className}></button>;
};
export default SortButtonBase;
